const navbar = {
  packages: "Paket", // translated 
  hotelPackages: "Paket Hotel", // translated 
  experiences: "Pengalaman", // translated 
  close: "Menutup", // translated 
  hotDeals: "Penawaran Menarik", // translated 
  dashboard: "Dasbor", // translated 
  pricing: "Harga", // translated 
};


export default navbar;
